import { useState } from 'react';
import { Menu, Shield, Lock } from 'lucide-react';
import { Link, Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Footer } from './Footer';

export function Layout() {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    return (
        <div className="min-h-screen bg-brand-dark overflow-hidden flex flex-col font-sans selection:bg-brand-primary/30">
            {/* Navigation Bar */}
            <nav className="border-b border-slate-800 bg-slate-900/80 backdrop-blur-md sticky top-0 z-50 transition-all duration-300">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex items-center justify-between h-16 sm:h-20">
                        {/* Logo Area */}
                        <div className="flex items-center gap-3">
                            <Link to="/" className="group flex items-center gap-3 transition-opacity">
                                <div className="bg-brand-primary p-2 rounded-xl shadow-lg shadow-brand-primary/20 group-hover:scale-105 transition-transform flex items-center justify-center">
                                    <div className="relative">
                                        <Shield className="w-6 h-6 text-white" />
                                        <div className="absolute inset-0 flex items-center justify-center">
                                            <span className="text-[10px] font-bold text-brand-primary mt-0.5 ml-[1px]">E</span>
                                        </div>
                                    </div>
                                </div>
                                <span className="text-lg sm:text-xl font-bold tracking-tight text-white leading-none">
                                    EMI Flipbook
                                </span>
                            </Link>
                        </div>

                        {/* Right Actions */}
                        <div className="flex items-center gap-3 sm:gap-4">
                            <div className="hidden md:flex items-center gap-2 px-3 py-1.5 rounded-full bg-slate-800/50 border border-slate-700/50 text-xs font-medium text-slate-400">
                                <Lock className="w-3 h-3 text-slate-500" />
                                256-bit Encrypted
                            </div>

                            <button
                                onClick={() => setIsSidebarOpen(true)}
                                className="p-2.5 rounded-xl text-slate-400 hover:text-white hover:bg-slate-800 transition-all active:scale-95"
                                aria-label="Open menu"
                            >
                                <Menu className="w-6 h-6" />
                            </button>
                        </div>
                    </div>
                </div>
            </nav>

            <Sidebar
                isOpen={isSidebarOpen}
                onClose={() => setIsSidebarOpen(false)}
            />

            <main className="flex-1 relative">
                <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-slate-800/20 via-brand-dark to-brand-dark pointer-events-none" />
                <div className="relative z-10 w-full h-full">
                    <Outlet />
                </div>
            </main>

            <Footer />
        </div>
    );
}
